import { createFileRoute } from "@tanstack/react-router";

import SecurityFailed from "@/features/security/SecurityFailed";

export const Route = createFileRoute("/_auth/security-failed")({
  component: SecurityFailed,
});
